import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJVoiceItem from '../view/FJVoiceItem.jsx';
import { useSelector, useDispatch } from 'react-redux';
import FJActionTextToSpeech from '../../../../redux/action/FJActionTextToSpeech.js';
import FJConstant from '../../../../constants/FJConstant.js';
import FJTextToSpeechUtil from '../../../../util/FJTextToSpeechUtil.js';
import PropTypes from 'prop-types';
const FJVoiceItemContainer = props => {
    useLocalStore();
    const dispatch = useDispatch();
    const favoriteList = useSelector(state => state.textToSpeech.favoriteList);
    const loadingFavoriteIdList = useSelector(state => state.textToSpeech.loadingFavoriteIdList);
    const { info = {}, onUse, isFavorite = false, fromType = FJConstant.MICROSOFT } = props;

    const {
        audioUrl,
        imgUrl,
        description,
        name,
        value,
        languageLabel,
        isFavorite: tempIsFavorite,
        isFavoriteLoading = false,
    } = FJTextToSpeechUtil.getVoiceItemShowInfo(info, fromType, { favoriteList, loadingFavoriteIdList, isFavorite });

    const _onFavorite = e => {
        e?.stopPropagation();
        dispatch(FJActionTextToSpeech.onFavoriteAction(value, !tempIsFavorite));
    };

    const _onUse = e => {
        e?.stopPropagation();
        if (onUse) {
            onUse({ ...info, fromType });
        }
    };

    return (
        <FJVoiceItem
            audioUrl={audioUrl}
            imgUrl={imgUrl}
            description={description}
            name={name}
            value={value}
            language={languageLabel}
            hasFavorite={fromType === FJConstant.MICROSOFT || fromType === FJConstant.CLONE_BY_FLEX_CLIP}
            isFavorite={tempIsFavorite}
            onFavorite={_onFavorite}
            onUse={_onUse}
            isFavoriteLoading={isFavoriteLoading}
        />
    );
};

FJVoiceItemContainer.propTypes = {
    info: PropTypes.object,
    onUse: PropTypes.func,
    isFavorite: PropTypes.bool,
    fromType: PropTypes.string,
};
export default FJVoiceItemContainer;
